import React from "react";
import styles from "./page3.scss";
import pic1 from "./pic1.png";
import pic2 from "./pic2.png";
import { getRem } from "../../func";

function Page3(props) {
  return (
    <div className={styles["page3"]} ref={props.myRef}>
      <div className={styles["page3-main"]}>
        <div className={styles["page3-child1"]}>
          <div className={`${styles["page3-child1-title"]} animate2-wrapper`}>
            <div
              r="231"
              g="232"
              b="244"
              className={`maskBlock animate2`}
              style={{ background: "rgb(231, 232, 244)" }}
            />
            OUR
            <br />
            ADVANTAGE
          </div>

          <div className={styles["page3-child1-subTitle"]}>
            <div className={styles["page3-child1-subTitle-circle"]}>5</div>
            <div className={styles["page3-child1-subTitle-text"]}>
              我们的优势 - <span style={{ color: "#32535D" }}>专业</span>
            </div>
          </div>

          <div className={`${styles["page3-child1-content"]} animate1-wrapper`}>
            <div
              r="231"
              g="232"
              b="244"
              className={`maskBlock animate1`}
              style={{ background: "rgb(231, 232, 244)" }}
            />

            <div className={styles["page3-child1-content-title"]}>
              TOP
              <span
                style={{
                  fontSize: getRem(16),
                  color: "#295A57",
                  position: "relative",
                  top: getRem(-3),
                  left: getRem(3),
                }}
              >
                顶级的国际资源
              </span>
              <br />
              INTERNATIONAL
              <br />
              RESOURCES
              <div className={styles["titleNumber"]}>1</div>
            </div>

            <div className={styles["page3-child1-content-desc"]}>
              我们拥有顶级的国际趋势时尚资源力量：与国外各大品牌（涵盖奢侈品牌，快消品牌，买手店，设计师品牌，版型等各品类）行业专家联手，提供“趋势+商品+买手+营销+企业管理”全方位服务与国际化创意思维。
            </div>

            <div className={styles["page3-child1-content-items"]}>
              <div style={{ fontWeight: "bold", color: "#295A57" }}>
                A. 奢侈品牌
              </div>
              <div style={{ color: "#111" }}>
                Dior设计总监(ROSEMARY RODRIGUEZ)、MaxMara总监、CELINE资深版师
              </div>

              <div style={{ fontWeight: "bold", color: "#295A57" }}>
                B.快销品牌
              </div>
              <div style={{ color: "#111" }}>
                ZARA买手总监（KATELL CHAIGNEAU）
              </div>

              <div style={{ fontWeight: "bold", color: "#295A57" }}>
                C.设计师品牌
              </div>
              <div style={{ color: "#111" }}>
                Yohji Yamamoto(山本耀司)CED、COMME des
                GARCONS（川久保玲）品牌顾问、PROMOSTYL
              </div>

              <div style={{ fontWeight: "bold", color: "#295A57" }}>D.版师</div>
              <div style={{ color: "#111" }}>
                Yohji Yamamoto(山本耀司)版师总监TEPPEI
                FUJITA，Prada女装版式（MIO GERALLO）、CELINE资深版师
              </div>

              <div style={{ fontWeight: "bold", color: "#295A57" }}>
                E. 工作室
              </div>
              <div style={{ color: "#111" }}>
                H&M设计组、CHANEL工坊、英国创意设计工作室FWS
                Design、CHLOE历史档案馆-打板工作室
              </div>
            </div>
          </div>

          <div
            className={styles["page3-icon"]}
            style={{ position: "absolute", bottom: "0", left: getRem(40) }}
          >
            <div className={styles.text}>PROFESSION</div>
            <div className={styles.area}></div>
          </div>
        </div>

        <div className={styles["page3-child2"]}>
          <div className={styles["page3-icon"]}>
            <div className={styles.text}>PROFESSION</div>
            <div className={styles.area}></div>
          </div>

          <div className={styles["page3-child2-pic"]}>
            <img src={pic1} />
          </div>

          <div className={`${styles["page3-child2-content"]} animate1-wrapper`}>
            <div
              r="231"
              g="232"
              b="244"
              className={`maskBlock animate1`}
              style={{ background: "rgb(231, 232, 244)" }}
            />

            <div className={styles["page3-child2-content-title"]}>
              <span style={{ fontSize: getRem(16), color: "#295A57" }}>
                专业的设计研发团队
              </span>
              <br />
              MEET OUR <br />
              GREAT TEAM
              <div
                className={styles["titleNumber"]}
                style={{
                  top: getRem(-15),
                  left: getRem(-60),
                  lineHeight: getRem(86),
                }}
              >
                2
              </div>
            </div>

            <div className={styles["page3-child2-content-text"]}>
              我们有具备专业艺术素养与资深行业经验的国内设计团队，也有遍布时尚产业各领域抓取国内外最新资讯的时尚猎手，并通过高密度的海外考察与内训课程，不断提升团队专业修养与国际眼界。
              <br />
              <br />
              我们对世界时尚动态的集体解密，可切实帮助企业解决从宏观趋势预测到设计再到产品落得的问题。
            </div>
          </div>
        </div>

        <div className={styles["page3-child3"]}>
          <div className={styles["page3-child3-title"]}>
            <span style={{ fontSize: getRem(16), color: "#295A57" }}>
              丰富的行业资源
            </span>
            <br />
            INDUSTRY <br />
            RESOURCES
            <div
              className={styles["titleNumber"]}
              style={{
                top: getRem(-15),
                left: getRem(-55),
                lineHeight: getRem(90),
              }}
            >
              3
            </div>
          </div>

          <div className={`${styles["page3-child3-desc"]} animate1-wrapper`}>
            <div
              r="231"
              g="232"
              b="244"
              className={`maskBlock animate1`}
              style={{ background: "rgb(231, 232, 244)" }}
            />
            我们与国内外专业机构如法国Première Vision
            Paris、各地行业协会、时尚教育机构、专业院校、贴牌商、生产商、面料商等保持长期合作，这些丰富的行业资源成为我们在业内始终保持业务领先的动力之一。
          </div>

          <div className={styles["page3-child3-icons"]}>
            <img src={pic2} />
          </div>

          <div
            className={styles["page3-icon"]}
            style={{ position: "absolute", bottom: "0" }}
          >
            <div className={styles.text}>PROFESSION</div>
            <div className={styles.area}></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page3;
